(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[110],{

/***/ 3626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9521);
/* harmony import */ var _components_CommonButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1139);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);





var Container = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Room__Container",
  componentId: "sc-jgksuf-0"
})(["", " h2{", "}", ""], {
  "backgroundBlendMode": "multiply",
  "backgroundPosition": "center",
  "backgroundSize": "cover",
  "backgroundAttachment": "fixed",
  "--tw-bg-opacity": "0.3",
  "backgroundColor": "rgba(52, 51, 57, var(--tw-bg-opacity))",
  "display": "flex",
  "flexDirection": "column",
  "flex": "none",
  "justifyContent": "center",
  "alignItems": "center",
  "height": "100vh",
  "width": "100vw"
}, {
  "marginBottom": "1rem",
  "textAlign": "center",
  "--tw-text-opacity": "1",
  "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
  "fontSize": "3rem",
  "lineHeight": "1"
}, function (_ref) {
  var bgUrl = _ref.bgUrl;
  return "background-image: url(".concat(bgUrl, ")");
});

var Room = function Room(_ref2) {
  var room = _ref2.room;
  return room && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(Container, {
    bgUrl: room.attributes.image.data.attributes.url,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h2", {
      children: room.attributes.place
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
      href: 'rooms/' + room.attributes.place.toLowerCase(),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_components_CommonButton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
          type: "inverse",
          children: "EXPLORE"
        })
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Room);

/***/ }),

/***/ 9174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9521);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7124);
/* harmony import */ var _components_Room__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3626);
/* harmony import */ var _components_TransitionScreen__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8066);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5893);









var Index = function Index(_ref) {
  var rooms = _ref.rooms;

  var PageHead = function PageHead() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("base", {
        href: "/"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("title", {
        children: "Products rooms"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("meta", {
        name: "description",
        content: "Come to see the room collections S\xD8LVE have to you."
      }, "desc"), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("meta", {
        property: "og:title",
        content: "S\xD8LVE Rooms"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("meta", {
        property: "og:description",
        content: "Come to see the room collections S\xD8LVE have to you."
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("meta", {
        property: "og:image",
        content: "/thumbnail.webp"
      })]
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(PageHead, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_TransitionScreen__WEBPACK_IMPORTED_MODULE_2__/* .TransitionScreen */ .B, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_Layout__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
        inHome: true,
        footerLess: true,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_StyledDiv, {
          id: "roomsWrapper",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_StyledDiv2, {
            children: rooms.map(function (room) {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_Room__WEBPACK_IMPORTED_MODULE_1__["default"], {
                room: room
              }, room.id);
            })
          })
        })
      })
    })]
  });
};

var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Index);

var _StyledDiv = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)("div").withConfig({
  displayName: "rooms___StyledDiv",
  componentId: "sc-1vzqje7-0"
})({
  "height": "100vh",
  "overflowX": "scroll",
  "overflowY": "hidden"
});

var _StyledDiv2 = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)("div").withConfig({
  displayName: "rooms___StyledDiv2",
  componentId: "sc-1vzqje7-1"
})({
  "display": "flex"
});

/***/ }),

/***/ 1815:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rooms",
      function () {
        return __webpack_require__(9174);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [802,675,263,581,774,888,179], function() { return __webpack_exec__(1815); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);